//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import parse from 'date-fns/parse'
import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'
import addMonths from 'date-fns/addMonths'
import isBefore from 'date-fns/isBefore'
import isAfter from 'date-fns/isAfter'
import isEqual from 'date-fns/isEqual'

import slugify from 'slugify'

import qs from "qs";

import SingleEvent from './Event.vue'

export default {
  props: {
    showUpcoming: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: 'SEARCH FOR EVENTS'
    },
    keyword: {
      type: String,
      default: ''
    }
  },

  computed: {
    upcomingEventsOld() {
      return this.lodash.sampleSize(this.filteredEvents, 6);
    },
    filteredCount: function() {
      let filtered = this.lodash.filter(event.dates, (date) => {
        let d = parseISO( date.date );
        return isBefore( this.search.start_date, d );
      });
    },
    filteredEvents: function() {
      let filteredEvents = [];
      this.events.forEach((event) => {

        event.dates = this.lodash.filter(event.dates, (date) => {
          let d = parseISO( date.date );
          return isBefore( this.search.start_date, d );
        });

        event.venue_url = `#/venue/${event.venue_id}-${slugify(event.venue_name)}`;

        filteredEvents.push( event );
      });

      return filteredEvents;
    },
    months: function() {

      return this.lodash.groupBy( this.filteredEvents, (event) => {
        let date = parseISO(event.raw_next_date);
        return format(date, 'MMMM')
      });

    },
    filtersActive: function() {
      let now = new Date();
      let then = addMonths(new Date(), 6);
      return format(this.search.start_date, 'MM/dd/yy') != format(now, 'MM/dd/yy') || format(this.search.end_date, 'MM/dd/yy') != format(then, 'MM/dd/yy') || this.search.keyword != '';
    }
  },
  watch: {

  },
  components: {
    SingleEvent
  },
  filters: {

  },
  data() {
    return { 
      
      loading: true,
      events: [],
      search: {
        start_date: new Date(),
        end_date: addMonths(new Date(), 6),
        keyword: '',
        city: '',
        page: 1,
        per_page: 20,
      },
      eventCount: 0,
      showLoadMore: false,
      keywordActive: false,
      cityOptions: [
       

      ],
      eventApiKey: eventApiKey,
      upcomingEvents: []

     
    }
  },
  mounted() {

    let self = this;



    this.search.keyword = this.keyword;

    

    this.getEvents();
    this.getUpcomingEvents();
 

  },
  methods: {
    printMonthSeparator(month) {
      return month.split(' ')[0]
    },
    printDate(dt, ps, fm) {
      return format( parse(dt, ps, new Date()), fm );
    },
    isoDate(dt, fm) {
      let date = parseISO(dt);
      //'MMMM yy'
      return format(date, fm)
    },
    lastIsoDate(event, fm) {

      let dt = event.dates[ event.dates.length - 1 ];
      let date = parseISO(dt.date);
      //'MMMM yy'
      return format(date, fm)
    },
    onCityChange(event) {
      this.setCity(event.target.value);
    },
    setCity(sub) {
      if (sub != this.search.city) {
        this.search.city = sub;
      } else {
        this.search.city = '';
      }
      this.search.page = 1;
      this.getEvents();
    },
    searchEvents() {
      this.search.page = 1;
      this.getEvents();
    },
    clearSearch() {
      this.search.keyword = '';
      this.search.start_date = new Date();
      this.search.end_date = addMonths(new Date(), 6);
      this.search.page = 1;
      this.getEvents();
    },
    loadMore() {
      this.search.page++;
      this.getEvents();
    },
    getEvents() {

      this.loading = true;


      let self = this;

      let url = 'https://api.everwondr.com/events/search2/'+this.eventApiKey;

      

      let data = {

        api_key: this.eventApiKey,
        per_page: this.search.per_page,
        page: this.search.page,
        pagination: this.search.page,
        radius: 15,
        sort_by: 'upcoming',
        show_featured: false,
        view_type: 'list',
        view_type_default: 'grid',
        start_date: format(this.search.start_date, 'MM/dd/yyyy'),
        //end_date: format(this.search.end_date, 'MM/dd/yyyy'),
        end_date: '',
        region: '',
        city: this.search.city,
        zip_codes: '',
        enable_city: true,
        domain_analytics: '',
        group_by_month: true,
        date_listing: 'list-by-month',
        search_term: this.search.keyword,
        city: this.search.city,
        //search_domain: 'http://localhost:3001',


      };

      this.keywordActive = this.keyword;


      let params = {
        data: data,
        //region_id: 0,
      }

      axios({
        method: 'post',
        url: url,
        data: qs.stringify(params)
      }).then((response) => {
         let newEvents = [];



          if (self.search.page == 1) {
            self.events = [];
            self.eventCount = response.data.num_results;
          }

          if (response.data.status != 'NO_RESULTS') {
            self.events = self.events.concat(response.data.items);

            if (response.data.items.length == self.search.per_page) {
              self.showLoadMore = true;
            } else {
              self.showLoadMore = false;
            }
          } else {
            self.events = [];
          }

          

          self.loading = false;
      });

/*
      $.ajax({
          type: "POST",
          url:url,
          //contentType: "application/json; charset=utf-8",
          data: qs.stringify( params ),
          //dataType: "json",
          success: function (response) {

              let newEvents = [];

           

              if (self.search.page == 1) {
                self.events = [];
                self.eventCount = response.count;
              }

              if (response.status != 'NO_RESULTS') {
                self.events = self.events.concat(response.items);
                console.log(self.events);

                if (response.items.length == self.search.per_page) {
                  self.showLoadMore = true;
                } else {
                  self.showLoadMore = false;
                }
              } else {
                self.events = [];
              }

              

              self.loading = false;

          },
          error: function (xhr, status, error) {
              
          }
      });


      */



    },
    getUpcomingEvents() {

      let self = this;

      let url = 'https://api.everwondr.com/events/search2/'+this.eventApiKey;

    
      let data = {

        api_key: this.eventApiKey,
        per_page: 6,
        page: this.search.page,
        pagination: this.search.page,
        radius: 15,
        sort_by: 'upcoming',
        show_featured: false,
        include: featuredEvents,
        view_type: 'list',
        view_type_default: 'grid',
        start_date: format(this.search.start_date, 'MM/dd/yyyy'),
        //end_date: format(this.search.end_date, 'MM/dd/yyyy'),
        end_date: '',
        region: '',
        city: this.search.city,
        zip_codes: '',
        enable_city: true,
        domain_analytics: '',
        group_by_month: true,
        date_listing: 'list-by-month',
        search_term: this.search.keyword,
        city: this.search.city,
        //search_domain: 'http://localhost:3001',


      };

      this.keywordActive = this.keyword;


      let params = {
        data: data,
        //region_id: 0,
      }

      axios({
        method: 'post',
        url: url,
        data: qs.stringify(params)
      }).then((response) => {
         
         this.upcomingEvents = response.data.items

      });


    }
  }
}




// WEBPACK FOOTER //
// ./scripts/components/Events.vue